import {
  Columns,
  Column,
  Stack,
  TextLink,
  Heading,
  Text,
} from 'braid-design-system';
import React from 'react';

import type { ClientListingForListingsTab } from 'src/types/graphql-derived';

import * as styles from './Statistics.css';

const Statistic = ({
  count,
  metric,
  link,
}: {
  count: number;
  metric: string;
  link?: string;
}) => {
  const headingStyle = link ? styles.textHoverUnderline : '';
  const textTone = link ? 'link' : 'neutral';

  return (
    <Stack space="small" align="center" data={{ testid: 'listing-statistic' }}>
      <Heading level="2" weight="weak">
        <span className={headingStyle}>{count}</span>
      </Heading>
      <Text tone={textTone} weight="regular" align="center">
        {link ? <TextLink href={link}>{metric}</TextLink> : metric}
      </Text>
    </Stack>
  );
};

interface StatisticsProps {
  listing: ClientListingForListingsTab;
}

const Statistics = ({ listing }: StatisticsProps) => (
  <Columns space="medium" alignY="top">
    <Column>
      <Statistic count={listing.searchCount} metric="Search views" />
    </Column>
    <Column>
      <Statistic count={listing.listingCount} metric="Ad views" />
    </Column>
    <Column>
      <Statistic
        link={`/sell/listings/${listing.id}/enquiries`}
        count={listing.enquiryCount}
        metric="Enquiries"
      />
    </Column>
  </Columns>
);

export default Statistics;
